<fa-stack class="close mt-1" size="1x" (click)="closeModal()">
  <fa-icon [icon]="['fas', 'circle']" stackItemSize="2x" class="circle"></fa-icon>
  <fa-icon [icon]="['far', 'x']" [inverse]="true" stackItemSize="1x"></fa-icon>
</fa-stack>
<img [src]="img" />
